export default __webpack_public_path__ + "static/media/element_spec_84.10d31bed.webp";